import { RemoteData, getIdList } from "./RemoteData"

/**
 * Data to show `Data point X of Y` on the UI,
 * where X is `foundAt + 1` and Y is `totalCount`
 */
export interface NavigationCursor {
    totalCount: number
    foundAt: number
}

/**
 * Returns a navigation cursor for given item in `RemoteData` if it is found.
 */
export function getCursor<M, P, K>(
    data: RemoteData<M, P, K>,
    id: K
): NavigationCursor | undefined {
    if (data.list === undefined) {
        return undefined
    }

    const index = getIdList(data).indexOf(id)

    return index === -1
        ? undefined
        : { foundAt: index, totalCount: data.list.total }
}
